
import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function About() {
  return (
    <div className="container" style={{ paddingTop: "150px", paddingBottom: "80px" }}>
        
      <Header />

      <div className="card">
        <h2 className="app-heading">About SmartPackr</h2>
        <p>
          SmartPackr was built to make travel stress-free and organized.
          Our intelligent packing list generator helps you plan smarter —
          adapting your checklist based on your destination, weather, and travel style.
        </p>
        <p>
          Whether you’re hitting the beach, hiking the mountains, or traveling for work,
          SmartPackr ensures you never forget the essentials.
        </p>
        <p>
          Our mission is simple — make packing effortless, so you can focus on the journey ahead.
        </p>
      </div>

      <div className="footer-nav">
        <nav>
            <Link to="/">Home</Link>
            <span>•</span>
            <Link to="/blog">Blog</Link>
            <span>•</span>
            <Link to="/about">About</Link>
            <span>•</span>
            <Link to="/privacy">Privacy Policy</Link>
        </nav>
        <p>© {new Date().getFullYear()} SmartPackr. All rights reserved.</p>
      </div>
    </div>
  );
}
